import { render, staticRenderFns } from "./GenericTitle.vue?vue&type=template&id=237f9cfc"
import script from "./GenericTitle.vue?vue&type=script&lang=js"
export * from "./GenericTitle.vue?vue&type=script&lang=js"
import style0 from "./GenericTitle.vue?vue&type=style&index=0&id=237f9cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports